import React, { useState, Fragment } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import $ from "jquery";
import useOnceEffect from "../../Hooks/useOnceEffect";
import user from "../../static/images/user_default.png";


function Aplicados() {
  const [vacantList, setvacantList] = useState([]);
  const [filterVacantList, setfilterVacantList] = useState([]);
  const [applicant, setapplicant] = useState("");
  const [cancvacant, setcancVacant] = useState("");
  const [loading, setloading] = useState(true);

  const userId = localStorage.getItem("userId");

  useOnceEffect(() => {
    axios.get("access/applicant/" + userId).then((result) => {
      setapplicant(result.data.applicantProfile);
      GetVacantList(result.data.applicantProfile.applicantProfileId);
    });
  });

  function GetVacantList(id) {
    axios
      .get("company-vacant/list-applicant-vacants/" + id)
      .then((result) => {
        setvacantList(result.data);
        setfilterVacantList(result.data);
        setloading(false);
      });
  }

  function FindAplicacion(id) {
    setcancVacant(
      vacantList.find((i) => i.companyDTOResponse.aplicarVacanteId === id)
    );
  }

  function CancelVacant() {
    axios
      .post(
        "company-vacant/close-applicant-vacant/" +
          cancvacant.companyDTOResponse.aplicarVacanteId
      )
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetVacantList(applicant.applicantProfileId);
          $("#cancelar-aplicacion-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#cancelar-aplicacion-modal").modal("hide");
      });
  }

  const SearchEmpleos = (e) => {
    let { value } = e.target;

    var filtered = vacantList.filter(function (str) {
      var myvar = str.companyDTOResponse.cargo;
      if (myvar) {
        return (
          (
            str.companyDTOResponse.cargo +
            " " +
            str.companyDTOResponse.name +
            " " +
            str.companyDTOResponse.tipoEmpleo +
            " " +
            str.companyDTOResponse.ubicacion
          )
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1
        );
      }
    });
    setfilterVacantList(filtered);
  };

  const active = {
    backgroundColor: "rgb(145 0 255)",
  };
  return (
    <Fragment>
      {loading ? (
        <div className="loader"></div>
      ) : (
        <section className="vacantes perfil-empresa usuario">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="">
                  <div className="bordered-box__container">
                    <div className="job-header vc">
                      <div className="job-header__top">
                        <div className="job-header__top-buttons">
                          <div className="job-header__notification form-check form-switch">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row vacancy__content" id="contenedorestadoaplicados">
              <div className="col-12 col-md-4" id="filtrobusqueda">
                <div className="vacancy__sidebar bordered-box mt-0">
                  <div className="bordered-box__header">
                    <div className="bordered-box__header-title">
                      Filtro de Búsqueda
                    </div>
                  </div>
                  <div className="vacancy__sidebar-content">
                    <form>
                      <input
                        type="search"
                        placeholder="Buscar"
                        aria-label="Search"
                        className="form-control"
                        onChange={(e) => {
                          SearchEmpleos(e);
                        }}
                      ></input>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-8" id="Estadoaplicante">
                <div className="vacancy__description bordered-box">
                  <div className="bordered-box__header">
                    <div className="bordered-box__header-title">
                      Estado de tus aplicaciones
                    </div>
                  </div>

                  {filterVacantList.map((item, index) => {
                    return (
                      <div key={index} className="recomendaciones">
                        <div className="box">
                          <div className="one-half">
                            <div className="head">
                              <div className="company__wrapper ">
                                <div
                                  className="logo"
                                  style={{
                                    border: "1px solid #DFDFDF",
                                    borderRadius: "25px",
                                  }}
                                >
                                  <img
                                    src={
                                      item.companyDTOResponse.fotoPerfilEmpresa 
                                      ? item.companyDTOResponse.fotoPerfilEmpresa
                                      : user
                                    }
                                    alt="aplicaciones"
                                    style={{
                                      width: "125px",
                                      height: "125px",
                                      borderRadius: "26px",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain"
                                    }}
                                  ></img>
                                </div>

                                <div className="content">
                                  <div className="cargo">
                                    {item.companyDTOResponse.cargo}
                                  </div>
                                  <div className="lugar">
                                    {" "}
                                    {item.companyDTOResponse.name}
                                  </div>
                                  <div className="cuidad">
                                    <Link
                                      to={`/user/Vacante/${item.companyDTOResponse.companyVacantId}`}
                                    >
                                      Ver Empleo
                                    </Link>
                                  </div>
                                </div>

                                <div className="aplicar">
                                  <div className="date">
                                    Fecha de Aplicación:{" "}
                                    <span>
                                      {item.companyDTOResponse.fechaAplicacion}
                                    </span>
                                  </div>
                                  <div className="estado">
                                    Estado: <span>Activo</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="body">
                              <div className="header-details-right">
                                <div className="header-details__state">
                                  <div className="header-details__state-bar">
                                    <div className="header-details__state-bar__items">
                                      <ul className="kr_progress-bar reset-list remove-list-style d-flex">
                                        {item.etapasVacante.map((item2) => {
                                          return (
                                            <li
                                              key={item2.orden}
                                              className={
                                                item2.completado
                                                  ? "compleado"
                                                  : ""
                                              }
                                            >
                                              {item2.completado ? (
                                                <span style={active}>
                                                  <i className="fas fa-check up-1"></i>
                                                </span>
                                              ) : (
                                                <span>
                                                  <i className="fas fa-check up-1"></i>
                                                </span>
                                              )}
                                              <a>{item2.nombreEtapa}</a>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="footer">
                              <div className="bottom-content">
                                <ul>
                                  <li>
                                    <a
                                      href="#"
                                      className="bg-gris"
                                      data-bs-toggle="modal"
                                      data-bs-target="#cancelar-aplicacion-modal"
                                      onClick={() =>
                                        FindAplicacion(
                                          item.companyDTOResponse
                                            .aplicarVacanteId
                                        )
                                      }
                                    >
                                      Cancelar aplicación
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <div
        id="cancelar-aplicacion-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    Cancelar Aplicacion
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Esta seguro que desea cancelar esta aplicacion?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => CancelVacant()}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Aplicados;
